import { eksmoBP } from 'Lib/bp/bp';
import { getW } from 'Lib/w/w';
import { speed } from 'Lib/speed/speed';

const $body = $('body');
const $menuScrollBlock = $('.menu-touch__scroll-block');
const $shadowBlock = $('.menu-touch__shadow');
let $menuScroll = $menuScrollBlock.scrollLeft();
const cShadowLeft = 'menu-touch__shadow_left';
const cShadowRight = 'menu-touch__shadow_right';

function menu() {
    menuStartScroll();

    // Временное решение

    setTimeout(() => {
        menuStartScroll();
    }, speed);

    setTimeout(() => {
        menuStartScroll();
    }, speed * 2);

    setTimeout(() => {
        menuStartScroll();
    }, speed * 5);

    // END Временное решение

    menuShadow();

    $menuScrollBlock.scroll(() => {
        menuShadow();
    });

    $body.on('eksmoResizeWidth', () => {
        menuStartScroll();
        menuShadow();
    });
}

// Показываем тени по краям
function menuShadow() {
    const wWidth = getW();

    if (wWidth <= eksmoBP.xsMax) {
        const $menuWidth = $('.menu-touch__list').width();

        if (wWidth > $menuWidth) {
            $shadowBlock.removeClass(cShadowRight);
        }

        $menuScroll = $menuScrollBlock.scrollLeft();
        $shadowBlock.toggleClass(cShadowLeft, $menuScroll > 0);
        $shadowBlock.toggleClass(cShadowRight, $menuScroll + wWidth !== $menuWidth.toFixed());
    }
}

function menuStartScroll() {
    const wWidth = getW();

    if (wWidth <= eksmoBP.xsMax) {
        const $menuSelect = $('.menu-touch__link_selected');

        if ($menuSelect.length) {
            const selectOffset = $menuSelect.position().left;
            const selectWidth = $menuSelect.innerWidth();

            if (wWidth < selectOffset + selectWidth) {
                $menuScrollBlock.scrollLeft(selectOffset + selectWidth * 0.5 - wWidth * 0.5);
            }
        }
    }
}

$body.on('eksmoFontLoad', menu);